import React, { memo, useState, useCallback, useEffect } from 'react'
import { makeStyles } from '@material-ui/styles'
import DoneIcon from '@material-ui/icons/Done'
import Paper from '@material-ui/core/Paper'
import IconButton from '@material-ui/core/IconButton'
import InputBase from '@material-ui/core/InputBase'
import SearchIcon from '@material-ui/icons/Search'
import { useQuery } from '@apollo/react-hooks'
import CustomScroll from 'react-custom-scroll'
import 'react-custom-scroll/dist/customScroll.css'

import styles from './styles'
import { FindTagsQuery } from 'store'
import { useDebounce } from 'utils'
import { AvailableTags, SelectedTags } from './'
import { useArticleState } from '../../../../../reducer'
import { useTagsState } from '../reducer'
import {
	ITag,
	ETagActionType,
	EArticleActionTypes,
	TSearchInputProps,
} from 'models'

const useStyles = makeStyles(styles)

const SearchContainer: React.FunctionComponent<TSearchInputProps> = ({
	placeholder,
}) => {
	const [{ available, selected: tags }, tagsDispatch] = useTagsState()
	const [, dispatch] = useArticleState()
	const [focused, setFocused] = useState(false)
	const { refetch } = useQuery(FindTagsQuery, {
		skip: true,
	})
	const classes = useStyles()
	const [inputText, setInputText] = useState('')
	const handleSearchChange = (event: any) => {
		if (event && event.target) setInputText(event.target.value)
	}
	const debouncedSearchTerm = useDebounce(inputText, 500)
	const saveTags = () => {
		dispatch({
			type: EArticleActionTypes.seITags,
			tags,
		})
	}
	const toggleFocused = useCallback(() => setFocused(!focused), [focused])
	const populateTagsState = (tags: ITag[]) => {
		tagsDispatch({
			type: ETagActionType.populate,
			tags,
		})
	}
	const [loading, setLoading] = useState(false)

	useEffect(() => {
		if (debouncedSearchTerm) {
			setLoading(true)
			const fetch = async () => {
				const result = await refetch({
					keyword: debouncedSearchTerm,
				})
				populateTagsState(result.data.tags)
				setLoading(false)
			}
			fetch()
		} else {
			populateTagsState([])
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [debouncedSearchTerm])

	return (
		<div
			className={classes.activeContainer}
			style={{ flexDirection: 'column' }}
		>
			<Paper className={classes.root} elevation={(focused && 1) || 3}>
				<div>
					<IconButton
						className={classes.iconButton}
						aria-label="Search"
					>
						<SearchIcon />
					</IconButton>
					<InputBase
						onChange={handleSearchChange}
						className={classes.input}
						placeholder={placeholder}
						inputProps={{
							'aria-label': placeholder,
							style: { padding: 0 },
						}}
						onFocus={toggleFocused}
					/>
					<IconButton
						className={classes.iconButton}
						aria-label="Search"
						onClick={saveTags}
					>
						<DoneIcon />
					</IconButton>
				</div>
				<div style={{ alignSelf: 'stretch' }}>
					<CustomScroll
						addScrolledClass={true}
						allowOuterScroll={true}
						heightRelativeToParent="100%"
						flex="1"
					>
						<AvailableTags
							pristine={inputText.length !== 0}
							loading={loading}
						/>
					</CustomScroll>
				</div>
			</Paper>
			{available.length === 0 && (
				<div>
					<SelectedTags />
				</div>
			)}
			{/* <div className={classes.searchHeader}>
				<SearchTagsInput tagging={tagging} />
				<Button
					variant="outlined"
					color="default"
					onClick={saveTags}
					className={classes.doneButton}
				>
					<DoneIcon classes={{ root: classes.iconRoot }} />
					{t('Done')}
				</Button>
			</div> */}
		</div>
	)
}

export default memo(SearchContainer)
